/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// NOTE (2026-06-11): the Klaviyo welcome-popup enhancement that used to live in
// this file moved to assets/evedia-klaviyo-popup.js (loaded from theme.liquid).
// It must exist in ONE place only — both copies carry a run-once guard
// (__evediaKlaviyoSkinPriorityInitialized), so a stale copy here wins the race
// and silently disables fixes shipped in the dedicated file.

// NOTE (2026-10-02): a block here briefly injected a <link> for
// assets/v26-cart-layout.css. Removed the same day — the hand-built URL had no
// `?v=` hash, so Shopify's CDN pinned the first upload and later edits never
// reached the browser. Those rules now live in assets/v26-fixes.css, block 11,
// which is loaded through asset_url and versioned properly. Do not re-add it.

/* =============================================================================
   "Subscription details" — send it somewhere useful (2026-10-01)

   THE PROBLEM (Krista, 1 Oct 2026, with screenshots)
   Seal's "Subscription details" link on a product card pointed at /pages/faqs
   with no fragment, so it landed at the top of a very long page — the
   Subscriptions group is around thirty questions down. "One would have to
   scroll quite a while to get to the subscription info."

   WHY IT COULD NOT JUST BE RE-POINTED
   The FAQ body is rich text stored on the Shopify PAGE, not in a theme
   section, and its <h2>s carry no id attributes. There was no anchor on the
   page to link to. Rather than edit Krista's copy (and put an id in prose she
   maintains), the ids are assigned here at runtime — reversible, and invisible
   in the page editor.

   The matching CSS lives in assets/v26-fixes.css, block 9 (scroll-margin-top,
   so the sticky header does not sit over the heading after the jump) and
   block 8 (the overflow fix for the popup being sliced in half).

   DEGRADES SAFELY: if this never runs, the link keeps its current behaviour —
   the FAQ page, from the top. Nothing breaks, it is just the old annoyance.
   ============================================================================= */
(function evediaSubscriptionDetails(){
  if (window.__evediaSubDetailsBound) return;
  window.__evediaSubDetailsBound = true;

  var ANCHOR = 'subscriptions';
  var TARGET = '/pages/faqs#' + ANCHOR;

  function slug(text){
    return String(text || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* ---- On the FAQ page: give every group heading an id ------------------- */
  function idFaqHeadings(){
    var heads = document.querySelectorAll('.ev-faq h2, .ev-faq h3');
    if (!heads.length) return false;
    for (var i = 0; i < heads.length; i++) {
      if (!heads[i].id) {
        var s = slug(heads[i].textContent);
        if (s) heads[i].id = s;
      }
    }
    /* The browser resolved (or failed to resolve) location.hash long before
       these ids existed, so arriving at /pages/faqs#subscriptions does NOT
       scroll on its own. Do it once, here. 'auto' rather than 'smooth': the
       customer asked to be taken to a specific answer, not shown a journey. */
    if (location.hash.length > 1) {
      var target = document.getElementById(location.hash.slice(1));
      if (target) target.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    return true;
  }

  /* ---- Everywhere else: retarget Seal's link ----------------------------- */
  function retargetLinks(){
    var links = document.querySelectorAll('.sls-subscription-details-label a[href]');
    var touched = 0;
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-evedia-sub-link') === '1') continue;
      var href = a.getAttribute('href') || '';
      /* Only rewrite the bare FAQ link Seal ships with. If someone later sets
         a deliberate destination in the Seal app's Translations panel, leave
         it alone — that is a person's decision, not a default to fix. */
      if (href !== '/pages/faqs' && href !== '/pages/faqs/') continue;
      a.setAttribute('href', TARGET);
      a.setAttribute('data-evedia-sub-link', '1');
      touched++;
    }
    return touched > 0;
  }

  /* Seal renders its widget asynchronously and re-renders it when the variant
     or plan changes, so one pass at load is not enough. Poll until the first
     link is found, then keep a light watch for ~20s and stop. Deliberately not
     IntersectionObserver or a scroll listener — see the note in
     snippets/v26-reliable-add.liquid: neither fires reliably on this theme. */
  function boot(){
    idFaqHeadings();

    var tries = 0;
    (function poll(){
      retargetLinks();
      if (++tries > 50) return;   /* ~20s at 400ms, then give up quietly */
      setTimeout(poll, 400);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
